import styled from 'styled-components'
import { media } from '../../utils'

export const Nav = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  height: 100px;
  margin: 0 auto;
  padding: 0 35px;
  overflow: hidden;

  .phone-item{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center; 
    p{
      font-weight: 500;
      letter-spacing: 0px;
      word-spacing: -1.5px;
      margin: 0px 5px;

    }
  }

  ${media.largePhone`
    padding: 0 15px;
    .phone-item {
      img{
        max-width: 30px;
      }
      margin-top: 9px;
      i {
        margin-left: 7.5px;
      }
      p, i {
        letter-spacing: 0px;
        word-spacing: -1.5px;
        font-size: 18px;
      }
    }
  `}
`

export const Logo = styled.div`
  display: flex;
  img {
    max-width: 214px;
  }
  ${media.largePhone`
    img {
      max-width: 144px;
    }
  `}
`



// WEBPACK FOOTER //
// ./src/components/layout/TopNavigationCleverStyle.js